import { render, staticRenderFns } from "./UserDeleteDialog.vue?vue&type=template&id=cfb193ce&scoped=true"
import script from "./UserDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./UserDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./UserDeleteDialog.vue?vue&type=style&index=0&id=cfb193ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb193ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfb193ce')) {
      api.createRecord('cfb193ce', component.options)
    } else {
      api.reload('cfb193ce', component.options)
    }
    module.hot.accept("./UserDeleteDialog.vue?vue&type=template&id=cfb193ce&scoped=true", function () {
      api.rerender('cfb193ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/UserDeleteDialog.vue"
export default component.exports